import { createInstance } from '@amplitude/analytics-browser'

import { config } from '../config'
import { AppEvent, NpsEvent } from './events'

export async function logAppEvent(
  event: AppEvent,
  data?: Record<string, unknown>
): Promise<AppEvent> {
  const analytics = new TrackingAnalytics()

  await analytics.init()

  return analytics.logAppEvent(event, data)
}

export class Amplitude {
  protected _amplitudeInstance

  constructor(private _key: string) {
    this._amplitudeInstance = createInstance()
  }

  public init = async (): Promise<void> => await this._amplitudeInstance.init(this._key).promise
}

export class TrackingAnalytics extends Amplitude {
  constructor() {
    super(config.AMPLITUDE_KEY)
  }

  public logAppEvent = (event: AppEvent, data?: Record<string, unknown>): Promise<AppEvent> => {
    return new Promise((resolve, reject) => {
      this._amplitudeInstance
        .track({
          event_properties: data,
          event_type: event,
          user_properties: {
            Channel: config.AMPLITUDE_CHANNEL,
            Version: config.APP_VERSION,
          },
        })
        .promise.then(() => resolve(event))
        .catch((code: string) =>
          reject(`Sending event '${event}' to Amplitude failed, code: ${code}`)
        )
    })
  }
}

export class NpsAnalytics extends Amplitude {
  constructor() {
    super(config.AMPLITUDE_NPS_KEY)
  }

  public logAppEvent = (event: NpsEvent, data?: Record<string, unknown>): Promise<NpsEvent> => {
    return new Promise((resolve, reject) => {
      this._amplitudeInstance
        .track({
          event_properties: data,
          event_type: event,
          user_properties: { App: config.AMPLITUDE_NPS_APP, Version: config.APP_VERSION },
        })
        .promise.then(() => resolve(event))
        .catch((code: string) =>
          reject(`Sending event '${event}' to Amplitude failed, code: ${code}`)
        )
    })
  }
}
